"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAppSettings = getAppSettings;
exports.getAppSetting = getAppSetting;
exports.setAppSettings = setAppSettings;
/**
 * Holds the application settings
 */

var appSettings;

function getAppSettings() {
  return appSettings;
}
/**
 * if default value is 'undefined' raises error if key is missing
 * @param key
 * @param defaultValue
 */


function getAppSetting(key, defaultValue) {
  if (!appSettings[key]) {
    if (defaultValue === undefined) {
      throw new Error("Required value for key: ".concat(key, " is missing in appSettings."));
    }

    return defaultValue;
  }

  return appSettings[key];
}

function setAppSettings(settings) {
  appSettings = settings;
  return appSettings;
}